module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "search_individual_claim",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("\n        Search an individual claim\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        Please enter claimant reference or name to search claims\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__g-4 u-flex-grow-none"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-2 u-flex-grow-none"
  }, [_c('button', {
    staticClass: "a-button a-button--small u-no-margin"
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('th', [_vm._v("Your Reference")]), _vm._v(" "), _c('th', [_vm._v("Claim Type")]), _vm._v(" "), _c('th', [_vm._v("Claimant Name")]), _vm._v(" "), _c('th', [_vm._v("Defendant Name")]), _vm._v(" "), _c('th', [_vm._v("Claimant Solicitor")]), _vm._v(" "), _c('th', [_vm._v("Updated At")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('icon-tooltip', {
    attrs: {
      "tooltip-text": "load",
      "side": "left",
      "text-width": "100",
      "icon-type": "load"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f1fca18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/modal/IndividualSearchModal.vue
// module id = 1654
// module chunks = 0